export interface Article {
    slug: string;
    title: string;
    description: string;
    date: string;
    image: string;
}

export const articles: Article[] = [
    {
        slug: 'hello',
        title: 'hello world',
        description: 'first post. just standing up the blog system.',
        date: 'March, 2026',
        image: '/image-2.webp',
    },
];
